<template>
  <div class="c-shopping-cart-notification" :class="checkedVariant">
    <div class="c-shopping-cart-notification__icon" :class="checkedVariant">
      <i
        v-if="checkedVariant === 'warning'"
        class="far fa-exclamation-triangle"
      ></i>
      <i v-if="checkedVariant === 'info'" class="far fa-info-circle"></i>
      <i v-if="checkedVariant === 'error'" class="far fa-times"></i>
      <i v-if="checkedVariant === 'success'" class="far fa-check"></i>
      <i v-if="checkedVariant === 'default'" class="far fa-info-circle"></i>
    </div>
    <div class="c-shopping-cart-notification__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoppingCartNotification',
  props: {
    variant: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    checkedVariant() {
      return this.variant || 'default';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-shopping-cart-notification {
  display: inline-flex;
  border-radius: 3px;
  overflow: hidden;
  align-items: stretch;

  &.warning {
    background-color: rgba($warning, 0.08);
  }

  &.info {
    background-color: rgba($primary, 0.08);
  }

  &.error {
    background-color: rgba($danger, 0.08);
  }

  &.success {
    background-color: rgba($success-light, 0.08);
  }

  &.default {
    background-color: rgba($grey, 0.08);
  }

  &__icon {
    color: $white;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;

    &.warning {
      background-color: $warning;
    }

    &.info {
      background-color: $primary;
    }

    &.error {
      background-color: $danger;
    }

    &.success {
      background-color: $success-light;
    }

    &.default {
      background-color: $grey;
    }
  }

  &__content {
    display: flex;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    padding: 6px 15px 6px 15px;
  }
}
</style>
